import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';

// Send the session cookie on every API request. Required because public-server.js
// uses express-session cookies for auth and axios defaults to "same-origin" only,
// which can drop cookies in some browsers when the front-end is served from a
// different port during dev (CRA dev server on 3001 → API on 5001 via proxy).
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
